import { QueryApiService } from 'src/common/api-service';
import { AuditableEntity } from '../common';
import { JobRoleJobSkill } from './job-roles-job-skills-api';

export interface JobSkill extends AuditableEntity<string> {
  name: string;
  roles: JobRoleJobSkill[];
  isDraft: boolean;
}

export class JobSkillApiService extends QueryApiService<JobSkill> {
  constructor() {
    super('jobSkills');
  }
}
